import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AgentConfig } from '@/config/agent-config';

interface AgentState {
  selectedAgent: AgentConfig | null;
}

const initialState: AgentState = {
  selectedAgent: null,
};

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setSelectedAgent(state, action: PayloadAction<AgentConfig>) {
      state.selectedAgent = action.payload;
    },
    clearSelectedAgent(state) {
      state.selectedAgent = null;
    },
  },
});

export const { setSelectedAgent, clearSelectedAgent } = agentSlice.actions;
export default agentSlice.reducer;
